<script>
import ApdexLabels from '@/components/charts/utils/ApdexLabels.vue';
import SemiGuageLegends from '@/components/charts/utils/SemiGuageLegends.vue';

export default {
  name: 'ChartGauge',
  components: { ApdexLabels, SemiGuageLegends },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getOptions() {
      return {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        colors: [this.getChartColor()],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            hollow: {
              size: '30%',
            },
            track: {
              background: this.getTrackBackground(),
              strokeWidth: '98%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -2,
                fontSize: '1.5rem',
                fontFamily: 'RakutenSansUI-regular',
                color: 'rgb(255, 255, 255)',
                formatter: this.getFormattedValue(),
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
      };
    },
    getValue() {
      return isNaN(this.data[0]?.avgNum) ? -1 : this.data[0]?.avgNum;
    },
    series() {
      if (this.item?.formatSeries) return this.item.formatSeries(this.getValue);
      return [this.getValue * 100 || 0];
    },
    getTitle() {
      return this.item?.title;
    },
    showApdexInfo() {
      return this.item?.showApdexInfo || false;
    },
    showGuageLegends() {
      return this.item?.showGuageLegends || false;
    },
  },
  methods: {
    getChartColor() {
      if (this.item?.getChartColor)
        return this.item?.getChartColor(this.getValue);

      return this.getValue > 0.83
        ? 'rgb(59, 191, 85)'
        : this.getValue > 0.68
          ? 'rgb(239, 183, 0)'
          : 'rgb(241, 103, 85)';
    },
    getTrackBackground() {
      if (this.item?.getTrackBackground)
        return this.item?.getTrackBackground(this.getValue);
      return 'rgb(255 ,255 ,255)';
    },
    getFormattedValue() {
      if (this.item?.formatValue) return this.item?.formatValue;
      return (val) => val;
    },
  },
};
</script>

<template>
  <div :class="item.enabled ? 'chart-gauge' : 'chart-gauge-disabled'">
    <div class="gauge-semi-chart-container">
      <div v-if="getTitle" class="gauge-semi-chart-title">
        {{ getTitle }}
      </div>
      <SemiGuageLegends
        v-if="showGuageLegends"
        :value="getValue"
        :leftLabel="item.leftLabel"
        :rightLabel="item.rightLabel"
      />
      <apexchart
        ref="radialBar"
        type="radialBar"
        :options="getOptions"
        :series="series"
        height="250"
      ></apexchart>
      <ApdexLabels
        v-if="showApdexInfo"
        :good="item.good"
        :fair="item.fair"
        :poor="item.poor"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gauge-semi-chart-container {
  height: 10rem;
}
.gauge-semi-chart-title {
  @include flex-center-vert;
  height: 2.375em;
  border-bottom: 0.0063em solid $border-primary;
  padding-left: 1rem;
  font-family: $semi-bold;
}
.chart-gauge {
  height: 100%;
  width: 100%;
}
.chart-gauge-disabled {
  height: 100%;
  width: 100%;
  opacity: 0.5;
}
</style>
